import { motion } from "framer-motion";
import { imgSrc } from "../../data/artworks";
import { Reveal, Eyebrow, MaskLines, EASE } from "./Reveal";
import { useT } from "../../lib/content";

export const Hearts = ({ items, onOpen }) => {
  const t = useT();
  return (
  <section id="coeurs" className="relative py-24 sm:py-32 lg:py-40" data-testid="coeurs-story-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-12 gap-14 lg:gap-12 items-center">
      <div className="lg:col-span-4">
        <Eyebrow>{t("hearts_eyebrow")}</Eyebrow>
        <h2 className="f-display mt-5 text-5xl sm:text-6xl font-light leading-[1] text-[#15202B]">
          <MaskLines inView lines={[t("hearts_title1"), <em key="e">{t("hearts_title2")}</em>]} />
        </h2>
        <Reveal className="mt-8 space-y-5 text-[#2E3B47] text-base sm:text-lg font-light leading-relaxed">
          <p>{t("hearts_p1")}</p>
          <p>{t("hearts_p2")}</p>
        </Reveal>
        <Reveal delay={0.1} className="mt-8 f-sign text-4xl text-[#8A6420]">{t("hearts_sign")}</Reveal>
      </div>
      <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
        {items.filter((a) => a.cat === "coeur").slice(0, 8).map((h, i) => (
          <motion.button key={h.id} type="button" onClick={() => onOpen(h)} data-testid={`coeur-grid-item-${i + 1}`}
            initial={{ opacity: 0, scale: 0.9, rotate: i % 2 ? 3 : -3 }} whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
            viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.9, ease: EASE, delay: i * 0.06 }}
            whileHover={{ y: -8 }}
            className={`group relative overflow-hidden aspect-square bg-[#E9E2D6] ${i % 4 === 1 || i % 4 === 3 ? "sm:translate-y-10" : ""}`}>
            <img src={imgSrc(h.img)} alt={`${h.t} : ${h.alt || ""}`} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110" />
            <span className="absolute inset-x-0 bottom-0 p-3 text-left text-xs tracking-[0.18em] uppercase text-white bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
              {h.vendu ? "Vendue" : h.t}
            </span>
          </motion.button>
        ))}
      </div>
    </div>
  </section>
  );
};
